import { useQuery } from "@tanstack/react-query";

import { apiClient } from "services/api";

/**
 * Fetches characteristics for a given client.
 *
 * Returns the TanStack Query result with `data` containing the JSON body:
 * `{ data: { [characteristicName]: value } }`.
 */
export function useClientCharacteristics(clientId: number) {
  return useQuery({
    queryKey: ["client", clientId, "characteristics"],
    queryFn: () =>
      apiClient
        .get<{ data: Record<string, string | null> }>(
          `/api/v0.0.3/clients/${clientId}/characteristics`
        )
        .then((r) => r.data),
    enabled: clientId > 0,
    staleTime: 5 * 60 * 1000,
  });
}
